module.exports = __webpack_public_path__ + "media/images/home/cover-desktop@2x-8d19d9da8cde5d0e226aaba82d50e38b.jpg";